import BasicOvace from './BasicOvace'
export default BasicOvace
